// frontend/src/pages/AprobacionesPage.jsx
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import './PostsPublicados.css';
import { useNavigate } from 'react-router-dom';
import contentService from '../services/contentService';
import authService from '../services/authService';
import PostDetailModal from '../components/PostDetailModal';

import Loading from '../components/Loading';
/* ── Constantes ─────────────────────────────────────────────────────── */
const HITOS = {
  idea_creativa: {
    label: 'Idea Creativa',
    color: '#7C3AED',
    bg:    '#F5F3FF',
    icon:  '💡',
  },
  copy: {
    label: 'Copy',
    color: '#0369A1',
    bg:    '#F0F9FF',
    icon:  '✍️',
  },
  contenido: {
    label: 'Contenido',
    color: '#B45309',
    bg:    '#FFFBEB',
    icon:  '🎬',
  },
};

function fmtFecha(iso) {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

function diasRestantes(iso) {
  if (!iso) return null;
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
  const pub = new Date(iso + 'T00:00:00');
  return Math.round((pub - hoy) / 86400000);
}



/* ── Sub-modal archivos de contenido ────────────────────────────────── */
function ContenidoModal({ archivos, aprobados, total, onClose, puedeAprobar, onAprobarMedia, procesando }) {
  const [visor, setVisor] = useState(null);
  const h = HITOS.contenido;

  return (
    <>
      <div style={{ ...S.overlay, zIndex: 1100 }} onClick={onClose}>
        <div style={{ ...S.modal, maxWidth: 680 }} onClick={e => e.stopPropagation()}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 18 }}>{h.icon}</span>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: h.color }}>Archivos de contenido</h3>
              <span style={{
                fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
                background: aprobados === total && total > 0 ? '#dcfce7' : h.bg,
                color: aprobados === total && total > 0 ? '#16a34a' : h.color,
              }}>
                {aprobados}/{total} aprobados
              </span>
            </div>
            <button onClick={onClose} style={S.closeBtn}>×</button>
          </div>

          {/* Grid de archivos */}
          {archivos.length === 0 ? (
            <p style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: 13, textAlign: 'center', padding: '32px 0' }}>
              Sin archivos subidos todavía.
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: '60vh', overflowY: 'auto', padding: 4 }}>
              {archivos.map((mf, i) => (
                <div key={mf.id || i} style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '10px 12px', borderRadius: 10, background: '#f8fafc',
                  border: `2px solid ${mf.aprobado ? '#22c55e' : '#e2e8f0'}`,
                }}>
                  {/* Thumbnail */}
                  <div
                    onClick={() => setVisor(mf.url)}
                    style={{
                      width: 64, height: 64, borderRadius: 8, overflow: 'hidden',
                      flexShrink: 0, cursor: 'pointer', background: '#e2e8f0',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                    }}
                  >
                    {mf.tipo === 'image' ? (
                      <img src={mf.thumbnail || mf.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <span style={{ fontSize: 28 }}>🎬</span>
                    )}
                    {mf.tipo === 'video' && (
                      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.3)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ color: '#fff', fontSize: 18 }}>▶</span>
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#1e293b' }}>
                      Archivo {i + 1} — {mf.tipo === 'image' ? 'Imagen' : 'Video'}
                    </div>
                    <div style={{
                      display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4,
                      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
                      background: mf.aprobado ? '#dcfce7' : '#fef3c7',
                      color: mf.aprobado ? '#16a34a' : '#d97706',
                    }}>
                      {mf.aprobado ? '✓ Aprobado' : '⏳ Pendiente'}
                    </div>
                  </div>

                  {/* Botones */}
                  <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                    <button
                      onClick={() => setVisor(mf.url)}
                      style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #e2e8f0',
                        background: '#fff', color: '#475569', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}
                    >
                      Ver
                    </button>
                    {puedeAprobar && (
                      mf.aprobado ? (
                        <button
                          onClick={() => onAprobarMedia?.(mf.id, true)}
                          disabled={procesando === mf.id}
                          style={{ padding: '5px 10px', borderRadius: 6, border: 'none',
                            background: procesando === mf.id ? '#e5e7eb' : '#fee2e2',
                            color: '#ef4444', fontSize: 11, fontWeight: 700,
                            cursor: procesando === mf.id ? 'not-allowed' : 'pointer' }}
                        >
                          {procesando === mf.id ? '…' : '✕ Quitar'}
                        </button>
                      ) : (
                        <button
                          onClick={() => onAprobarMedia?.(mf.id, false)}
                          disabled={procesando === mf.id}
                          style={{ padding: '5px 10px', borderRadius: 6, border: 'none',
                            background: procesando === mf.id ? '#e5e7eb' : '#22c55e',
                            color: '#fff', fontSize: 11, fontWeight: 700,
                            cursor: procesando === mf.id ? 'not-allowed' : 'pointer' }}
                        >
                          {procesando === mf.id ? '…' : '✓ Aprobar'}
                        </button>
                      )
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ marginTop: 14, textAlign: 'right' }}>
            <button onClick={onClose} style={{ ...S.btnVerPost, background: h.color }}>Cerrar</button>
          </div>
        </div>
      </div>

      {/* Visor imagen ampliada */}
      {visor && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 1200, background: 'rgba(0,0,0,0.88)',
            display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setVisor(null)}
        >
          <img
            src={visor}
            alt="Vista completa"
            style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8 }}
          />
          <button
            onClick={() => setVisor(null)}
            style={{ position: 'absolute', top: 20, right: 24, background: 'rgba(255,255,255,0.15)',
              border: 'none', color: '#fff', fontSize: 28, cursor: 'pointer', borderRadius: '50%',
              width: 42, height: 42, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            ×
          </button>
        </div>
      )}
    </>
  );
}

/* ── Sub-modal para ver texto completo ──────────────────────────────── */
function TextoCompletoModal({ titulo, texto, color, bg, icon, onClose }) {
  return (
    <div style={{ ...S.overlay, zIndex: 1100 }} onClick={onClose}>
      <div style={{ ...S.modal, maxWidth: 640 }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 18 }}>{icon}</span>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color }}>{titulo}</h3>
          </div>
          <button onClick={onClose} style={S.closeBtn}>×</button>
        </div>
        <div style={{
          background: bg, border: `1px solid ${color}22`,
          borderRadius: 10, padding: '16px 18px',
          fontSize: 14, color: '#1e293b', lineHeight: 1.7,
          whiteSpace: 'pre-wrap', maxHeight: '60vh', overflowY: 'auto',
        }}>
          {texto || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Sin contenido registrado.</span>}
        </div>
        <div style={{ marginTop: 14, textAlign: 'right' }}>
          <button onClick={onClose} style={{ ...S.btnVerPost, background: color }}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

/* ── Modal de detalle ───────────────────────────────────────────────── */
function DetalleModal({ post, onClose, onAprobado, permisos = {} }) {
  const [subModal, setSubModal] = React.useState(null);
  const [procesando, setProcesando] = React.useState(null); // 'idea'|'copy'|mediaId
  const [postLocal, setPostLocal] = React.useState(post);

  // Sincronizar cuando cambia el post externo
  React.useEffect(() => { setPostLocal(post); }, [post]);

  if (!postLocal) return null;

  const handleAprobarHito = async (tipo, accion = 'approved') => {
    if (procesando) return;
    let notas = '';
    if (accion === 'rejected') {
      notas = window.prompt('Notas de rechazo (opcional):') ?? '';
      if (notas === null) return;
    }
    setProcesando(tipo);
    try {
      if (tipo === 'idea_creativa') {
        await contentService.approveCreativeIdea(postLocal.id, accion, notas);
        const actualizado = { ...postLocal, idea_aprobada: accion === 'approved',
          pendientes: accion === 'approved'
            ? postLocal.pendientes.filter(p => p !== 'idea_creativa')
            : [...postLocal.pendientes, 'idea_creativa'].filter((v,i,a)=>a.indexOf(v)===i) };
        setPostLocal(actualizado);
        onAprobado?.(actualizado);
      } else if (tipo === 'copy') {
        await contentService.approveCopy(postLocal.id, accion, notas);
        const actualizado = { ...postLocal, copy_aprobado: accion === 'approved',
          pendientes: accion === 'approved'
            ? postLocal.pendientes.filter(p => p !== 'copy')
            : [...postLocal.pendientes, 'copy'].filter((v,i,a)=>a.indexOf(v)===i) };
        setPostLocal(actualizado);
        onAprobado?.(actualizado);
      }
    } catch (e) {
      alert(e.response?.data?.message || 'Error al procesar la aprobación');
    } finally {
      setProcesando(null);
    }
  };

  const handleAprobarMedia = async (mediaId, aprobado) => {
    if (procesando) return;
    setProcesando(mediaId);
    try {
      if (aprobado) {
        await contentService.unapproveMedia(mediaId);
      } else {
        await contentService.approveMedia(mediaId);
      }
      const nuevosArchivos = postLocal.media_archivos.map(mf =>
        mf.id === mediaId ? { ...mf, aprobado: !aprobado } : mf
      );
      const nuevosAprobados = nuevosArchivos.filter(mf => mf.aprobado).length;
      const actualizado = { ...postLocal, media_archivos: nuevosArchivos, media_aprobados: nuevosAprobados,
        pendientes: nuevosAprobados >= postLocal.media_total && postLocal.media_total > 0
          ? postLocal.pendientes.filter(p => p !== 'contenido')
          : [...new Set([...postLocal.pendientes, 'contenido'])] };
      setPostLocal(actualizado);
      onAprobado?.(actualizado);
    } catch (e) {
      alert('Error al procesar la aprobación del archivo');
    } finally {
      setProcesando(null);
    }
  };

  return (
    <>
      <div style={S.overlay} onClick={onClose}>
        <div style={S.modal} onClick={e => e.stopPropagation()}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: '#0f172a' }}>{postLocal.titulo}</h2>
              <span style={{ fontSize: 12, color: '#94a3b8', marginTop: 2, display: 'block' }}>
                {postLocal.status_display}
              </span>
            </div>
            <button onClick={onClose} style={S.closeBtn}>×</button>
          </div>

          {/* Info básica */}
          <div style={S.infoGrid}>
            <InfoItem label="Plataforma"  value={postLocal.plataforma} />
            <InfoItem label="Tipo"        value={postLocal.tipo_material} />
            <InfoItem label="Publicación" value={fmtFecha(postLocal.fecha_publicacion)} />
            <InfoItem label="Validación"  value={fmtFecha(postLocal.fecha_validacion)} />
            <InfoItem label="Creador"     value={postLocal.creador} />
            <InfoItem label="Cliente"     value={postLocal.cliente || '—'} />
          </div>

          {/* Hitos */}
          <h3 style={S.sectionTitle}>Hitos pendientes</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

            <HitoDetalle
              hito="idea_creativa"
              pendiente={postLocal.pendientes.includes('idea_creativa')}
              texto={postLocal.idea_creativa_texto}
              placeholder="Sin idea creativa registrada todavía."
              onVerCompleto={() => setSubModal('idea')}
              puedeAprobar={permisos.puedeAprobarIdea}
              onAprobar={() => handleAprobarHito('idea_creativa', 'approved')}
              onRechazar={() => handleAprobarHito('idea_creativa', 'rejected')}
              procesando={procesando === 'idea_creativa'}
            />

            <HitoDetalle
              hito="copy"
              pendiente={postLocal.pendientes.includes('copy')}
              texto={postLocal.copy_texto}
              placeholder="Sin copy registrado todavía."
              onVerCompleto={() => setSubModal('copy')}
              puedeAprobar={permisos.puedeAprobarCopy}
              onAprobar={() => handleAprobarHito('copy', 'approved')}
              onRechazar={() => handleAprobarHito('copy', 'rejected')}
              procesando={procesando === 'copy'}
            />

            <HitoDetalleMedia
              pendiente={postLocal.pendientes.includes('contenido')}
              aprobados={postLocal.media_aprobados}
              total={postLocal.media_total}
              onVerCompleto={() => setSubModal('contenido')}
            />
          </div>

          <div style={{ marginTop: 20, textAlign: 'right' }}>
            <a href={`/?open_post=${postLocal.id}`} style={S.btnVerPost} target="_blank" rel="noopener noreferrer">
              Ver en calendario →
            </a>
          </div>
        </div>
      </div>

      {/* Sub-modales */}
      {subModal === 'idea' && (
        <TextoCompletoModal
          titulo="Idea Creativa completa"
          texto={postLocal.idea_creativa_texto}
          color={HITOS.idea_creativa.color}
          bg={HITOS.idea_creativa.bg}
          icon={HITOS.idea_creativa.icon}
          onClose={() => setSubModal(null)}
        />
      )}
      {subModal === 'copy' && (
        <TextoCompletoModal
          titulo="Copy completo"
          texto={postLocal.copy_texto}
          color={HITOS.copy.color}
          bg={HITOS.copy.bg}
          icon={HITOS.copy.icon}
          onClose={() => setSubModal(null)}
        />
      )}
      {subModal === 'contenido' && (
        <ContenidoModal
          archivos={postLocal.media_archivos || []}
          aprobados={postLocal.media_aprobados}
          total={postLocal.media_total}
          onClose={() => setSubModal(null)}
          puedeAprobar={permisos.puedeAprobarContenido}
          onAprobarMedia={handleAprobarMedia}
          procesando={procesando}
        />
      )}
    </>
  );
}

function InfoItem({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 10, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>{value || '—'}</div>
    </div>
  );
}

function HitoDetalle({ hito, pendiente, texto, placeholder, onVerCompleto, puedeAprobar, onAprobar, onRechazar, procesando }) {
  const h = HITOS[hito];
  const tieneTexto = !!texto;
  return (
    <div style={{
      padding: '12px 14px', borderRadius: 10,
      background: pendiente ? h.bg : '#f0fdf4',
      border: `1px solid ${pendiente ? h.color + '33' : '#bbf7d0'}`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 14 }}>{h.icon}</span>
        <span style={{ fontWeight: 700, fontSize: 13, color: pendiente ? h.color : '#16a34a' }}>
          {h.label}
        </span>
        <span style={{
          fontSize: 10, fontWeight: 700,
          color: pendiente ? h.color : '#16a34a',
          background: pendiente ? h.color + '15' : '#dcfce7',
          padding: '2px 8px', borderRadius: 20,
        }}>
          {pendiente ? 'PENDIENTE' : 'APROBADO ✓'}
        </span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6, alignItems: 'center' }}>
          {tieneTexto && (
            <button onClick={onVerCompleto} style={{
              padding: '3px 10px', borderRadius: 6,
              border: `1px solid ${h.color}55`, background: '#fff',
              color: h.color, fontSize: 11, fontWeight: 700, cursor: 'pointer',
            }}>
              Ver completo
            </button>
          )}
          {/* Botones de aprobación — solo si hay texto y está pendiente */}
          {pendiente && tieneTexto && puedeAprobar && (
            <>
              <button
                onClick={onAprobar}
                disabled={procesando}
                style={{
                  padding: '3px 12px', borderRadius: 6, border: 'none',
                  background: procesando ? '#d1fae5' : '#22c55e', color: '#fff',
                  fontSize: 11, fontWeight: 700,
                  cursor: procesando ? 'not-allowed' : 'pointer',
                  opacity: procesando ? 0.7 : 1,
                }}
              >
                {procesando ? '…' : '✓ Aprobar'}
              </button>
              <button
                onClick={onRechazar}
                disabled={procesando}
                style={{
                  padding: '3px 12px', borderRadius: 6, border: 'none',
                  background: procesando ? '#fee2e2' : '#ef4444', color: '#fff',
                  fontSize: 11, fontWeight: 700,
                  cursor: procesando ? 'not-allowed' : 'pointer',
                  opacity: procesando ? 0.7 : 1,
                }}
              >
                {procesando ? '…' : '✕ Rechazar'}
              </button>
            </>
          )}
          {pendiente && tieneTexto && !puedeAprobar && (
            <span style={{ fontSize: 10, color: '#94a3b8', fontStyle: 'italic' }}>Sin permiso</span>
          )}
        </div>
      </div>
      {tieneTexto && (
        <p style={{ margin: '8px 0 0', fontSize: 12, color: '#475569', lineHeight: 1.5, fontStyle: 'italic',
          display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
        }}>
          "{texto}{texto.length >= 120 ? '…' : ''}"
        </p>
      )}
      {!tieneTexto && pendiente && (
        <p style={{ margin: '6px 0 0', fontSize: 12, color: '#94a3b8', fontStyle: 'italic' }}>{placeholder}</p>
      )}
    </div>
  );
}

function HitoDetalleMedia({ pendiente, aprobados, total, onVerCompleto }) {
  const h = HITOS.contenido;
  const pct = total > 0 ? Math.round((aprobados / total) * 100) : 0;
  return (
    <div style={{
      padding: '12px 14px', borderRadius: 10,
      background: pendiente ? h.bg : '#f0fdf4',
      border: `1px solid ${pendiente ? h.color + '33' : '#bbf7d0'}`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 14 }}>{h.icon}</span>
        <span style={{ fontWeight: 700, fontSize: 13, color: pendiente ? h.color : '#16a34a' }}>
          Contenido multimedia
        </span>
        <span style={{
          fontSize: 10, fontWeight: 700,
          color: pendiente ? h.color : '#16a34a',
          background: pendiente ? h.color + '15' : '#dcfce7',
          padding: '2px 8px', borderRadius: 20,
        }}>
          {pendiente ? 'PENDIENTE' : 'APROBADO ✓'}
        </span>
        {total > 0 && (
          <button
            onClick={onVerCompleto}
            style={{
              marginLeft: 'auto', padding: '3px 10px', borderRadius: 6,
              border: `1px solid ${h.color}55`, background: '#fff',
              color: h.color, fontSize: 11, fontWeight: 700, cursor: 'pointer',
            }}
          >
            Ver detalle
          </button>
        )}
      </div>
      {total > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 10 }}>
          <div style={{ flex: 1, height: 6, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{
              height: '100%', borderRadius: 4, width: `${pct}%`,
              background: pct === 100 ? '#22c55e' : '#f59e0b',
            }} />
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', whiteSpace: 'nowrap' }}>
            {aprobados}/{total} aprobados
          </span>
        </div>
      )}
      {total === 0 && pendiente && (
        <p style={{ margin: '6px 0 0', fontSize: 12, color: '#94a3b8', fontStyle: 'italic' }}>Sin archivos subidos todavía.</p>
      )}
    </div>
  );
}

const PLAT_COLORS = {
  Instagram: '#833AB4', Facebook: '#1877F2', TikTok: '#010101',
  Twitter: '#1DA1F2', LinkedIn: '#0A66C2', YouTube: '#FF0000',
};

/* ── Tarjeta de post ─────────────────────────────────────────────────── */
function PostCard({ post, onClick }) {
  const [hovered, setHovered] = useState(false);
  const dias = diasRestantes(post.fecha_publicacion);
  const diasColor = dias == null ? '#94a3b8'
    : dias < 0 ? '#dc2626'
    : dias <= 2 ? '#d97706'
    : dias <= 7 ? '#ca8a04'
    : '#16a34a';
  const diasTxt = dias == null ? '—'
    : dias === 0 ? 'hoy'
    : dias < 0   ? `hace ${Math.abs(dias)}d`
    : `en ${dias}d`;
  const platColor = PLAT_COLORS[post.plataforma] || '#64748b';

  return (
    <div
      onClick={() => onClick(post)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 16,
        background: '#fff',
        border: `1px solid ${hovered ? '#cbd5e1' : '#e8edf5'}`,
        borderRadius: 12,
        padding: '14px 18px',
        cursor: 'pointer',
        transition: 'box-shadow .15s, border-color .15s',
        boxShadow: hovered ? '0 2px 12px rgba(0,0,0,.08)' : '0 1px 3px rgba(0,0,0,.04)',
      }}
    >
      {/* Ícono plataforma */}
      <div style={{
        width: 40, height: 40, borderRadius: 10, flexShrink: 0,
        background: platColor + '18',
        color: platColor,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 18,
      }}>
        <i className={
          post.plataforma === 'Instagram' ? 'bi bi-instagram'
          : post.plataforma === 'TikTok' ? 'bi bi-tiktok'
          : post.plataforma === 'Facebook' ? 'bi bi-facebook'
          : post.plataforma === 'YouTube' ? 'bi bi-youtube'
          : 'bi bi-phone'
        } />
      </div>

      {/* Contenido principal */}
      <div style={{ flex: 1, minWidth: 0 }}>
        {/* Título */}
        <div style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', lineHeight: 1.3,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {post.titulo}
        </div>

        {/* Etiqueta */}
        {post.etiqueta && (
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', alignItems: 'center', marginTop: 4 }}>
            <span style={{
              padding: '2px 8px', borderRadius: 20, fontSize: 10, fontWeight: 700,
              background: (post.etiqueta_color || '#3B82F6') + '22',
              color: post.etiqueta_color || '#3B82F6',
              border: `1px solid ${(post.etiqueta_color || '#3B82F6')}44`,
            }}>{post.etiqueta}</span>
          </div>
        )}

        {/* Meta: tipo de contenido, cuenta, cliente, editores, archivos — badges neutros */}
        <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', alignItems: 'center', marginTop: 5 }}>
          {[
            post.tipo_material,
            post.influencer,
            post.cliente,
            post.creador,
            post.media_total > 0 ? `${post.media_aprobados}/${post.media_total} archivos` : null,
          ].filter(Boolean).map((texto, i) => (
            <span key={i} style={{
              padding: '2px 9px', borderRadius: 20, fontSize: 11, fontWeight: 700,
              color: '#64748b', background: '#f1f5f9', border: '1px solid #e2e8f0',
            }}>{texto}</span>
          ))}
        </div>

        {/* Aprobación pendiente */}
        {post.pendientes.length > 0 && (
          <div style={{ marginTop: 15 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.03em', textTransform: 'uppercase', marginBottom: 4 }}>
              Aprobación pendiente:
            </div>
            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', alignItems: 'center' }}>
            {post.pendientes.map(h => {
              const info = HITOS[h];
              return info ? (
                <span key={h} style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4,
                  padding: '2px 9px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                  color: info.color, background: info.bg, border: `1px solid ${info.color}33`,
                }}>
                  <i className={
                    h === 'idea_creativa' ? 'bi bi-lightbulb'
                    : h === 'copy' ? 'bi bi-pencil'
                    : h === 'contenido' ? 'bi bi-camera-reels'
                    : 'bi bi-circle'
                  } />
                  {info.label}
                </span>
              ) : null;
            })}
            </div>
          </div>
        )}
      </div>

      {/* Fecha */}
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#334155' }}>
          {fmtFecha(post.fecha_publicacion)}
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, color: diasColor, marginTop: 2 }}>
          {diasTxt}
        </div>
      </div>
    </div>
  );
}

/* ── Página principal ───────────────────────────────────────────────── */
export default function AprobacionesPage() {
  const [posts, setPosts]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [filtro, setFiltro]     = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [postModalId, setPostModalId] = useState(null);

  const fetchData = useCallback(() => {
    setLoading(true);
    contentService.getAprobacionesPendientes()
      .then(res => { setPosts(res.data.posts || []); setError(null); })
      .catch(() => setError('No se pudo cargar la lista de aprobaciones.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const postsFiltrados = useMemo(() => {
    let lista = posts;
    if (filtro !== 'todos') lista = lista.filter(p => p.pendientes.includes(filtro));
    if (busqueda.trim()) {
      const q = busqueda.toLowerCase();
      lista = lista.filter(p =>
        p.titulo.toLowerCase().includes(q) ||
        (p.cliente || '').toLowerCase().includes(q) ||
        (p.plataforma || '').toLowerCase().includes(q) ||
        p.editores.some(e => e.nombre.toLowerCase().includes(q))
      );
    }
    return lista;
  }, [posts, filtro, busqueda]);

  const conteos = useMemo(() => ({
    idea_creativa: posts.filter(p => p.pendientes.includes('idea_creativa')).length,
    copy:          posts.filter(p => p.pendientes.includes('copy')).length,
    contenido:     posts.filter(p => p.pendientes.includes('contenido')).length,
  }), [posts]);

  return (
    <div style={S.page}>
      {/* Header */}
      <div style={S.header}>
        <div className="pig-topbar-left">
          <h1 className="pig-topbar-title">
            <i className="bi bi-check2-circle" /> Aprobaciones
          </h1>
          <p className="pig-topbar-sub">Posts con al menos un hito sin aprobar</p>
        </div>
        <button style={S.btnRefresh} onClick={fetchData}>
          <i className="bi bi-arrow-clockwise" /> Actualizar
        </button>
      </div>

      {/* Chips de filtro */}
      <div style={S.resumenRow}>
        <ChipFiltro label="Todos" count={posts.length} activo={filtro === 'todos'} color="#475569" onClick={() => setFiltro('todos')} />
        <ChipFiltro label={<><i className="bi bi-lightbulb" /> Idea Creativa</>} count={conteos.idea_creativa} activo={filtro === 'idea_creativa'} color={HITOS.idea_creativa.color}
          onClick={() => setFiltro(filtro === 'idea_creativa' ? 'todos' : 'idea_creativa')} />
        <ChipFiltro label={<><i className="bi bi-pencil" /> Copy</>} count={conteos.copy} activo={filtro === 'copy'} color={HITOS.copy.color}
          onClick={() => setFiltro(filtro === 'copy' ? 'todos' : 'copy')} />
        <ChipFiltro label={<><i className="bi bi-camera-reels" /> Contenido</>} count={conteos.contenido} activo={filtro === 'contenido'} color={HITOS.contenido.color}
          onClick={() => setFiltro(filtro === 'contenido' ? 'todos' : 'contenido')} />
      </div>

      {/* Buscador */}
      <div style={S.searchWrap}>
        <span style={S.searchIcon}>🔍</span>
        <input
          style={S.searchInput}
          placeholder="Buscar por título, cliente, plataforma o editor…"
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
        />
        {busqueda && <button onClick={() => setBusqueda('')} style={S.clearBtn}>×</button>}
      </div>

      {/* Estados */}
      {error   && <div style={S.errorBox}>{error}</div>}
      {loading && !error && <Loading fullScreen={false} mensaje="Cargando aprobaciones" />}

      {/* Lista de tarjetas */}
      {!loading && !error && (
        postsFiltrados.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#94a3b8', fontSize: 14 }}>
            Sin aprobaciones pendientes
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {postsFiltrados.map(p => (
              <PostCard key={p.id} post={p} onClick={() => setPostModalId(p.id)} />
            ))}
          </div>
        )
      )}

      <p style={{ fontSize: 11, color: '#cbd5e1', marginTop: 12, textAlign: 'right' }}>
        {postsFiltrados.length} de {posts.length} posts · Excluye publicados, programados y eliminados
      </p>

      {postModalId && (
        <PostDetailModal
          postId={postModalId}
          onClose={() => { setPostModalId(null); fetchData(); }}
          onUpdate={() => fetchData()}
        />
      )}
    </div>
  );
}

/* ── Chip de filtro ─────────────────────────────────────────────────── */
function ChipFiltro({ label, count, activo, color, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 7,
        padding: '7px 14px', borderRadius: 20, cursor: 'pointer',
        border: `2px solid ${activo ? color : '#e2e8f0'}`,
        background: activo ? color + '12' : '#fff',
        color: activo ? color : '#64748b',
        fontSize: 13, fontWeight: 600,
        transition: 'all .15s',
      }}
    >
      {label}
      <span style={{
        background: activo ? color : '#e2e8f0',
        color: activo ? '#fff' : '#64748b',
        borderRadius: 20, padding: '1px 7px', fontSize: 11, fontWeight: 800,
      }}>
        {count}
      </span>
    </button>
  );
}

/* ── Styles ──────────────────────────────────────────────────────────── */
const S = {
  page:        { padding: '28px 32px', maxWidth: 1200, margin: '0 auto', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: '#1a1a1a' },
  header:      { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, gap: 12, flexWrap: 'wrap' },
  title:       { margin: 0, fontSize: 22, fontWeight: 700 },
  subtitle:    { margin: '4px 0 0', color: '#666', fontSize: 13 },
  btnRefresh:  { padding: '7px 16px', background: '#f1f5f9', color: '#334155', border: '1px solid #e2e8f0', borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: 'pointer', flexShrink: 0 },
  resumenRow:  { display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' },
  searchWrap:  { position: 'relative', display: 'flex', alignItems: 'center', marginBottom: 16 },
  searchIcon:  { position: 'absolute', left: 12, fontSize: 14, pointerEvents: 'none' },
  searchInput: { width: '100%', padding: '9px 36px 9px 36px', border: '1px solid #e2e8f0', borderRadius: 10, fontSize: 13, color: '#1e293b', background: '#fff', outline: 'none', boxSizing: 'border-box' },
  clearBtn:    { position: 'absolute', right: 10, background: 'none', border: 'none', fontSize: 18, color: '#94a3b8', cursor: 'pointer', padding: '0 4px' },
  errorBox:    { background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '12px 16px', borderRadius: 8, fontSize: 14, marginBottom: 16 },
  loading:     { textAlign: 'center', padding: '60px 0', color: '#94a3b8', fontSize: 14 },
  card:        { background: '#fff', border: '1px solid #e8edf5', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,.06)', overflow: 'hidden' },
  table:       { width: '100%', borderCollapse: 'collapse' },
  th:          { padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.5px', borderBottom: '1px solid #f1f5f9', background: '#f8fafc', whiteSpace: 'nowrap' },
  td:          { padding: '12px 14px', fontSize: 13, verticalAlign: 'middle', borderBottom: '1px solid #f8fafc' },
  // Modal
  overlay:     { position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  modal:       { background: '#fff', borderRadius: 16, padding: '24px 28px', maxWidth: 560, width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,.2)' },
  closeBtn:    { background: 'none', border: 'none', fontSize: 24, color: '#94a3b8', cursor: 'pointer', padding: 0, lineHeight: 1 },
  infoGrid:    { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 20px', padding: '14px 16px', background: '#f8fafc', borderRadius: 10, marginBottom: 20 },
  sectionTitle:{ margin: '0 0 10px', fontSize: 13, fontWeight: 700, color: '#334155', textTransform: 'uppercase', letterSpacing: '.4px' },
  btnVerPost:  { display: 'inline-block', padding: '8px 18px', background: '#0f172a', color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: 'none' },
};
